module.exports = __webpack_public_path__ + "img/_audio.e0f6ff80.png";